module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "describe"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("脱贫人数")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.itemData1))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("未脱贫人数")]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.itemData2))])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail-item"
  }, [_vm._v("电商扶贫企业数（家）：324")]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_vm._v("电商带动贫困户数（户）：7293")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail-item"
  }, [_vm._v("贫困户电商产品数（种）：19")]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_vm._v("电商扶贫增收（元/每户）：2007")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43e29508!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpPoor/center/centerTop/index.vue
// module id = 1992
// module chunks = 2